export const QUESTION_STATUS = {
  ASKED: "asked",
  RIGHT: "answeredRight",
  WRONG: "answeredWrong",
};
